export const homeRoutes = {
  root: '/',
  homePage: '/account',
  accountCreate: '/account/create',
  accountRegister: '/account/register',
  signIn: '/account/signin',
  resetPin: '/account/resetpin',
  forgotPassword: '/account/forgotpassword',
  passwordRecovery: '/account/passwordrecovery',
  changeEmail: '/account/changeemail',
  changeEmailConfirm: '/account/confirmemailchange',
};
